import { useQuery } from "@apollo/client";
import React, { useEffect, useState } from "react";
import * as Ionicons from "react-icons/io";
import ReactTable from "react-table";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import { Button, Card, CardBody, Col, Row } from "reactstrap";
import {
  CHECK_USER_STATUS,
  QUERY_GET_ALL_PUB_INFO,
  QUERY_SPECIFIC_SUPPORTER_PUB_INFO,
} from "../../../../queries";
import DropdownIsHold from "./DropDownIsHold";
import EditLink from "./EditLink";
import EditLinkPdf from "./EditLinkPdf";
import EditPdf from "./EditPdf";
import { useParams } from "react-router-dom";
import { useUserEmail } from "../../../../Layout/AppMain/LoginStatusContext";

const TabPublishedInformation = ({ publicView = false }) => {
  const { supporterId = null } = useParams();
  const CloseIcon = Ionicons["IoIosClose"];
  const SettingIcon = Ionicons["IoIosSettings"];

  const [isEdit, setIsEdit] = useState(false);
  const [publishedInformationData, setPublishedInformationData] = useState([]);

  const allPubInfo = useQuery(QUERY_GET_ALL_PUB_INFO);
  const specificPubInfo = useQuery(QUERY_SPECIFIC_SUPPORTER_PUB_INFO, {
    variables: { supporterId },
  });

  const { data: checkUserStatus } = useQuery(CHECK_USER_STATUS, {
    variables: {
      email: useUserEmail(),
    },
  });

  const canEdit =
    checkUserStatus?.allUsers?.edges[0]?.node?.supporterRole === "can_edit" ||
    checkUserStatus?.allUsers?.edges[0]?.node?.supporterRole === "CAN_EDIT";

  useEffect(() => {
    if (publicView) {
      if (!specificPubInfo.data) return;
      let data = [];
      specificPubInfo.data.allPublishedInformationCategory.edges.forEach(
        (parent) => {
          return parent.node.publshedInformation.edges.forEach((child) =>
            data.push({
              category: parent.node.title,
              ...child.node,
            })
          );
        }
      );
      setPublishedInformationData(data);
      return;
    } else {
      if (!allPubInfo.data) return;
      let data = [];
      allPubInfo.data.allPublishedInformationCategory.edges.forEach(
        (parent) => {
          return parent.node.publshedInformation.edges.forEach((child) =>
            data.push({
              category: parent.node.title,
              ...child.node,
            })
          );
        }
      );
      setPublishedInformationData(data);
    }
  }, [allPubInfo, publicView, specificPubInfo]);

  useEffect(() => {
    window.addEventListener("error", (e) => {
      if (
        e.message === "ResizeObserver loop limit exceeded" ||
        e.message ===
          "ResizeObserver loop completed with undelivered notifications."
      ) {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client-overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
  }, []);

  return (
    <Card className="mb-2  org_contentarea">
      <div className="org_subtitle_sec">
        <div
          className="org_subtitle"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h4 style={{ fontSize: 16, marginBottom: 0, fontWeight: "bold" }}>
            情報開示
          </h4>
        </div>
        {isEdit ? (
          <Button className="ema__btn__update" onClick={() => setIsEdit(false)}>
            <CloseIcon fontSize="17px" />
          </Button>
        ) : (
          <>
            {canEdit && (
              <Button
                className="ema__btn__edit"
                onClick={() => setIsEdit(true)}
                {...(publicView && {
                  style: { display: "none" },
                })}
              >
                <SettingIcon fontSize="20px" />
                <span className="pl-2">情報の編集</span>
              </Button>
            )}
          </>
        )}
      </div>
      <CSSTransitionGroup
        component="div"
        transitionName="TabsAnimation"
        transitionAppear={true}
        transitionAppearTimeout={0}
        transitionEnter={false}
        transitionLeave={false}
      >
        <Row>
          <Col md="12">
            <CardBody>
              <ReactTable
                getTdProps={(state, rowInfo, column, instance) => {
                  return {
                    onClick: (e) => {
                      //if(column.id !== 'col-check'){
                      // 基本的な処理
                      //  return
                      //}
                    },
                  };
                }}
                data={publishedInformationData}
                columns={[
                  {
                    Header: "カテゴリー",
                    Cell: ({ row }) => {
                      return (
                        <div style={{ textAlign: "center", width: "100%" }}>
                          {row?._original?.category}
                        </div>
                      );
                    },
                  },
                  {
                    Header: "項目",
                    width: 400,
                    Cell: ({ row }) => {
                      return (
                        <div style={{ textAlign: "center", width: "100%" }}>
                          {row?._original?.title}
                        </div>
                      );
                    },
                  },
                  {
                    Header: "有無",
                    width: 100,
                    Cell: ({ row }) => {
                      return (
                        <div style={{ textAlign: "center", width: "100%" }}>
                          {row?._original?.supporterPublishedInfomation
                            ?.edges[0]?.node?.isHold === true
                            ? "◯"
                            : "-"}
                          {isEdit ? (
                            <div style={{ marginTop: "10px" }}>
                              <DropdownIsHold
                                id={row?._original?.id}
                                refetch={allPubInfo?.refetch}
                                type="hold"
                              />
                            </div>
                          ) : null}
                        </div>
                      );
                    },
                  },
                  {
                    Header: "開示",
                    width: 100,
                    Cell: ({ row }) => {
                      return (
                        <div style={{ textAlign: "center", width: "100%" }}>
                          {row?._original?.supporterPublishedInfomation
                            ?.edges[0]?.node?.isPublished === true
                            ? "◯"
                            : "-"}
                          {isEdit ? (
                            <div style={{ marginTop: "10px" }}>
                              <DropdownIsHold
                                id={row?._original?.id}
                                refetch={allPubInfo?.refetch}
                                type="published"
                              />
                            </div>
                          ) : null}
                        </div>
                      );
                    },
                  },
                  {
                    Header: "掲載ページ",
                    Cell: ({ row }) => {
                      return (
                        <div
                          style={{
                            textAlign: "center",
                            width: "100%",
                            display: "flex",
                            gap: "10px",
                            flexDirection: "column",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              gap: "1rem",
                            }}
                          >
                            {row?._original?.supporterPublishedInfomation
                              ?.edges[0]?.node?.referenceUrl ? (
                              <a
                                style={{ margin: "0px", width: "50%" }}
                                href={
                                  row?._original?.supporterPublishedInfomation
                                    ?.edges[0]?.node?.referenceUrl
                                }
                              >
                                URL
                              </a>
                            ) : (
                              <p
                                style={{
                                  margin: "0px",
                                  width: "50%",
                                  color: "#0000005e",
                                }}
                              >
                                URL
                              </p>
                            )}
                            {row?._original?.supporterPublishedInfomation
                              ?.edges[0]?.node?.pdfUrl ? (
                              <a
                                style={{ margin: "0px", width: "50%" }}
                                href={
                                  row?._original?.supporterPublishedInfomation
                                    ?.edges[0]?.node?.pdfUrl
                                }
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                PDF
                              </a>
                            ) : (
                              <p
                                style={{
                                  margin: "0px",
                                  width: "50%",
                                  color: "#0000005e",
                                }}
                              >
                                PDF
                              </p>
                            )}
                          </div>

                          {isEdit && (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                              }}
                            >
                              <EditPdf
                                publishedInformationId={row?._original?.id}
                                refetch={allPubInfo?.refetch}
                                // link={row?._original?.supporterPublishedInfomation?.edges[0]?.node?.pdfUrl}
                              />
                              <EditLink
                                id={row?._original?.id}
                                refetch={allPubInfo?.refetch}
                                link={
                                  row?._original?.supporterPublishedInfomation
                                    ?.edges[0]?.node?.referenceUrl
                                }
                              />
                            </div>
                          )}

                          {/* <div
                            style={{
                              textAlign: "center",
                              width: "50%",
                              display: "inline-block",
                            }}
                          >
                            {row?._original?.supporterPublishedInfomation?.edges[0]?.node?.referenceUrl 
                              ? (
                                  <a
                                    style={{ margin: "0px" }}
                                    href={
                                      row?._original?.supporterPublishedInfomation
                                        ?.edges[0]?.node?.referenceUrl
                                    }
                                  >
                                    URL
                                  </a>
                                ) 
                              : (
                                  <p style={{ margin: "0px", color: "gray" }}>
                                    URL
                                  </p>
                                )
                            }
                            {isEdit 
                              ? (
                                  <div style={{ marginTop: "10px" }}>
                                    <EditLink
                                      id={row?._original?.id}
                                      refetch={allPubInfo?.refetch}
                                      link={
                                        row?._original?.supporterPublishedInfomation
                                          ?.edges[0]?.node?.referenceUrl
                                      }
                                    />
                                  </div>
                                ) 
                              : null
                            }
                          </div>
                          <div style={{ width: "5%" }} />
                          <div
                            style={{
                              textAlign: "center",
                              width: "50%",
                              display: "inline-block",
                            }}
                          >
                            {row?._original?.supporterPublishedInfomation?.edges[0]?.node?.referenceUrl 
                              ? (
                                  <a
                                    style={{ margin: "0px" }}
                                    href={
                                      row?._original?.supporterPublishedInfomation
                                        ?.edges[0]?.node?.pdfUrl
                                    }
                                  >
                                    PDF
                                  </a>
                                ) 
                              : (
                                  <p style={{ margin: "0px", color: "gray" }}>
                                    PDF
                                  </p>
                                )
                            }
                            {isEdit 
                              ? (
                                  <div style={{ marginTop: "10px" }}>
                                    <EditPdf
                                      publishedInformationId={row?._original?.id}
                                      refetch={allPubInfo?.refetch}
                                      // link={row?._original?.supporterPublishedInfomation?.edges[0]?.node?.pdfUrl}
                                    />
                                  </div>
                                ) 
                              : null
                            }
                          </div> */}
                        </div>
                      );
                    },
                  },
                ]}
                // defaultPageSize={25}
                // previousText="前へ"
                // nextText="次へ"
                // pageText=""
                // ofText="情報開示"
                // rowsText=""
                className="-striped -highlight"
                style={{ cursor: "pointer" }}
                showPaginationBottom={false}
              />
            </CardBody>
          </Col>
        </Row>
      </CSSTransitionGroup>
    </Card>
  );
};

export default TabPublishedInformation;
